<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g>
      <rect x="10" y="16.8" width="10.31" height="3" fill="currentcolor"/>
      <rect x="10" y="25.2" width="10.31" height="3" fill="currentcolor"/>
      <rect x="10" y="8.39" width="25.23" height="3" fill="currentcolor"/>
      <polygon points="5 44.95 2 44.95 2 1.94 3.86 -.01 43 -.01 43 14.54 40 14.54 40 2.99 5.14 2.99 5 3.14 5 44.95" fill="currentcolor"/>
    </g>
    <path d="M32.69,31.8l-4.15-.02-5-5.16.05-5.28c0-3.73,2.31-6.15,5.88-6.15h2.47c3.1,0,5.72,2.82,5.72,6.17,0,2.73.01,4.65.01,4.66v.61s-4.98,5.18-4.98,5.18ZM29.82,28.78h1.61s3.25-3.37,3.25-3.37c0-.78,0-2.24,0-4.06,0-1.5-1.12-3.17-2.72-3.17h-2.47c-2.38,0-2.88,1.72-2.88,3.17l-.04,4.06,3.26,3.37Z" fill="currentcolor"/>
    <polygon points="18.23 44.95 18.22 38.23 22.52 34.07 29.13 34.06 30.46 35.46 31.83 34.05 38.67 34.04 43 38.24 43 44.94 40 44.94 40 39.51 37.46 37.04 33.1 37.05 30.44 39.8 27.85 37.06 23.74 37.07 21.22 39.5 21.23 44.94 18.23 44.95" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>